import React, { useState, useEffect } from 'react';
import '../app/scss/application.scss';
import axios from 'axios';
import store from 'store';
import { HashRouter  as Router, Switch, Route, Redirect, useHistory } from 'react-router-dom';
import Disposable from '../mixins/Disposable'
import SideNavMenu from '../components/SideNavMenu';
import messages from '../services/Messages';
import notification from '../services/Notification';
import LoginService from '../app/services/LoginService';
import LoginPage from './pages/LoginPage';
import NoSuchRoutePage from './pages/NoSuchRoutePage';
import DropoffPage from './pages/DropoffPage';
import EditDropoffPage from './pages/EditDropoffPage';
import EditJobPage from './pages/EditJobPage';
import FieldAssetManagementPage from './pages/FieldAssetManagementPage';
import ReceivingPage from './pages/ReceivingPage';
import RejectReasonPage from './pages/RejectReasonPage';
import SAPJobProgressPage from './pages/SAPJobProgressPage';
import JobProgressPage from './pages/JobProgressPage';
import InspectionPage from './pages/InspectionPage';
import SerializedAssetSearchPage from './pages/SerializedAssetSearchPage';
import SerializedAssetDetailPage from './pages/SerializedAssetDetailPage';
import ReceivingTicketPage from './pages/ReceivingTicketPage';
import ShippingTicketPage from './pages/ShippingTicketPage';
import EditAssetPage from './pages/EditAssetPage';
import CreateNewAssetPage from './pages/CreateNewAssetPage';
import ShipReceivedAssetsPage from './pages/ShipReceivedAssetsPage';
import JobProgressAssetsPage from './pages/JobProgressAssetsPage';
import InspectionAttachmentPage from './pages/InspectionAttachmentPage';
import JobAttachmentPage from './pages/JobAttachmentPage';
import NotesPage from './pages/NotesPage';
import QuotesDetailPage from './pages/QuotesDetailPage';
import AdhocTransactionsPage from './pages/AdhocTransactionsPage';
import TransferAssetsToJobPage from './pages/TransferAssetsToJobPage';
import ShipAssetsPage from './pages/ShipAssetsPage';
import ReceivingTicketDetailPage from './pages/ReceivingTicketDetailPage';
import ShippingTicketDetailPage from './pages/ShippingTicketDetailPage';
import UsersPage from './pages/UsersPage';
import CustomerPage from './pages/CustomerPage';
import FacilitiesPage from './pages/FacilitiesPage';
import EditUserPage from './pages/EditUserPage';
import EditCustomerPage from './pages/EditCustomerPage';
import CustomerDocumentUploadPage from './pages/CustomerDocumentUploadPage';
import EditFacilityPage from './pages/EditFacilityPage';
import ConfigureCustomerPage from './pages/ConfigureCustomerPage';
import ServiceLevelLinkPage from './pages/ServiceLevelLinkPage';
import BroadcastMessagesPage from './pages/BroadcastMessagesPage';
import ManufacturerDescriptionPage from './pages/ManufacturerDescriptionPage';
import EditManufacturerDescriptionPage from './pages/EditManufacturerDescriptionPage';
import CustomerDescriptionPage from './pages/CustomerDescriptionPage';
import EditCustomerDescriptionPage from './pages/EditCustomerDescriptionPage';
import ListPage from './pages/ListPage';
import BillOfMaterialPage from './pages/BillOfMaterialPage';
import MonitorInterfacePage from './pages/MonitorInterfacePage';
import LaborCodePage from './pages/LaborCodePage';
import ContainerPage from './pages/ContainerPage';
import EditLaborCodePage from './pages/EditLaborCodePage';
import GaugeManagementPage from './pages/GaugeManagementPage';
import AdminQueryPage from './pages/AdminQueryPage';
import ReportsPage from './pages/ReportsPage';
import AddReleaseNotesPage from './pages/AddReleaseNotesPage';
import ReleaseNotesPage from './pages/ReleaseNotesPage';
import ManualPressureTestPage from './pages/ManualPressureTestPage';
import CustomerServiceLevelPage from './pages/CustomerServiceLevelPage';
import CustomerLocationPage from './pages/CustomerLocationPage';
import EditAssetDescriptionPage from './pages/EditAssetDescriptionPage';
import EditFieldAssetPage from './pages/EditFieldAssetPage';
import ScannedQRAssetsPage from './pages/ScannedQRAssetsPage';
import SelectServiceLevelPage from './pages/SelectServiceLevelPage';
import LibertyReportPage from './pages/LibertyReportPage';
import ScrollToTop from '../ScrollToTop';
import AssemblyWorkOrderPage from './pages/AssemblyWorkOrderPage';
import CreateNewAWOPage from './pages/CreateNewAWOPage';
import SelectAssemblyLevelPage from './pages/SelectAssemblyLevelPage';
import AssemblyPage from './pages/AssemblyPage';
import AwoAttachmentPage from './pages/AwoAttachmentPage';
import AssemblyProgressPage from './pages/AssemblyProgressPage'
import EditAwoPage from './pages/EditAwoPage';
import DuplicateAwoPage from './pages/DuplicateAwoPage';
import CustomerAssemblyLevelPage from './pages/CustomerAssemblyLevelPage';
import ShipAwoAssetsPage from './pages/ShipAwoAssetsPage';
import SAPService from '../../src/app/services/SAPService';
import Home from './pages/Home';

import { Security, SecureRoute, LoginCallback, useOktaAuth } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import config from './config';
import CorsErrorModal from './CorsErrorModal';
import AuthRequiredModal from './AuthRequiredModal';
const oktaAuth = new OktaAuth(config.oidc);

//over riding ajax server configuration for edc development environment
if (process.env.REACT_APP_ENV_NAME === 'edcDevelopment') {
    axios.interceptors.request.use(function (config) {
        const location = window.location;
        if (location && location.protocol === 'https:') {
            config.url = config.url.replace('http:', 'https:');
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
}

const AppRouter = () => {
    return (
      <Router> 
        <AppWrapper /> 
      </Router>
    )
  }

const AppWrapper = Disposable((props) => {

  LoginService.updateLoginInfoFormLocalStore();
  const [loginInfo, setLoginInfo] = useState(LoginService.loginInfo);
  const isAdministrator = LoginService.isAdministrator;
  const isCoordinator = LoginService.isCoordinator;
  const isTechnician = LoginService.isTechnician;
  const isTechnicianWithoutDataClerk = LoginService.isTechnicianWithoutDataClerk;
  const isCustomer = LoginService.isCustomer;
  const isSAPRep = LoginService.isSAPRep;
  const isSuperUser = LoginService.isSuperUser;
  const loginDetail = store.get('InteServLoginInfo');
  const dmsEnabledFacility = loginDetail ? loginDetail.enableDMS : false;
  const defaultRoute = isCustomer ? '/fieldasset' : '/dropoff';
  const sapFacility = SAPService.isSAPFacility();
  // const isLibertycustomer = LoginService.isLibertycustomer;
    const [corsErrorModalOpen, setCorsErrorModalOpen] = React.useState(false);
    const [authRequiredModalOpen, setAuthRequiredModalOpen] = React.useState(false);
    
    const history = useHistory(); // example from react-router

    const triggerLogin = async () => {
      await oktaAuth.signInWithRedirect();
    };
  
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
      history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };
  
    const customAuthHandler = async () => {
      const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
      if (!previousAuthState || !previousAuthState.isAuthenticated) {
        // App initialization stage
        await triggerLogin();
      } else {
        // Ask the user to trigger the login process during token autoRenew process
        setAuthRequiredModalOpen(true);
      }
    };
  
    const onAuthResume = async () => {
      console.log('onAuthResume');
      history.push('/login');
    };
 

   
    useEffect(() => {
        //customAuthHandler();        
        props.using(
            messages.channel('login').action('loggedin').subscribe(loginInfo => { setLoginInfo(loginInfo) }),
            messages.channel('loginService').action('update').subscribe(() => { setLoginInfo(LoginService.loginInfo) }),
            messages.channel('broadcast-messages').action('send').subscribe(data => {
                if (data) {
                    const message = data.message;
                    if (!message) {
                        return;
                    }
                    notification.action(message.action).post(message);
                }
            })
        );
        return () => {
            props.terminate();
        };
    }, []);

    const links = [
        { to: '/dropoff', icon: 'fas fa-truck fa-flip-horizontal', title: 'Equipment Drop-Off', canShow: ((isSAPRep || isTechnician) && !isCustomer) },
        { to: '/fieldasset', icon: 'fa fa-bullseye', title: 'Iron Management Portal', canShow: (isAdministrator || isCustomer || isSuperUser) },
        { to: '/receiving', icon: 'fa fa-download', title: 'Receive Assets', canShow: isTechnician && !isCustomer },
        { to: '/rejectreason', icon: 'fa fa-thumbs-down', title: 'Reject Reason Mapping', canShow: isTechnician && !isCustomer },
        { to: '/sapjobprogress', icon: 'fa fa-comments', title: 'SAP Job Progress', canShow: isSAPRep && !isCustomer },
        { to: '/gaugemanagement', icon: 'fa fa-tachometer-alt', title: 'Gauge Management', canShow: !isCustomer && dmsEnabledFacility },
        { to: '/jobprogress', icon: 'fa fa-cog', title: 'Job Progress', canShow: ((isCoordinator || isTechnician) && !isCustomer) },
        { to: '/inspection', icon: 'fa fa-cogs', title: 'Inspection', canShow: isTechnician && !isCustomer },
        { to: '/assemblyworkorder', icon: 'fa fa-sharp fa-solid fa-cubes', title: 'Assembly Work Order', canShow: !isCustomer && loginInfo },
        { to: '/assembly', icon: 'fa fa-puzzle-piece', title: 'Assembly' ,canShow: !isCustomer && loginInfo },
        { to: '/containers', icon: 'fab fa-dropbox', title: 'Containers', canShow: isTechnicianWithoutDataClerk && !isCustomer },
        { to: '/assetsearch', icon: 'fa fa-search', title: 'Serialized Asset Search', canShow: (isTechnician || isCustomer || isSAPRep) },
        { to: '/receivingtickets', icon: 'fa fa-ticket-alt fa-flip-both', title: 'Receiving Tickets', canShow: (isTechnician && !isCustomer) },
        { to: '/shippingtickets', icon: 'fa fa-truck', title: 'Shipping Tickets', canShow: ((isSAPRep || isTechnician) && !isCustomer) },
        { to: '/customers', icon: 'fa fa-briefcase', title: 'Customers', canShow: (isAdministrator || isSuperUser) },
        { to: '/facilities', icon: 'far fa-building', title: 'Facilities', canShow: (isAdministrator || isSuperUser) },
        { to: '/users', icon: 'fas fa-users', title: 'User', canShow: (isAdministrator || isSuperUser) },
        { to: '/lists', icon: 'fa fa-th-list', title: 'List Management', canShow: isAdministrator },
        { to: '/manufacturerdescription', icon: 'fa fa-th-large', title: 'Manufacturer Description Management', canShow: (isAdministrator || isSuperUser) },
        { to: '/customerdescription', icon: 'fa fa-th', title: 'Customer Description Management', canShow: (isAdministrator || isSuperUser) },
        { to: '/laborcodes', icon: 'fa fa-anchor', title: 'Labor Code Management', canShow: (isAdministrator || isSuperUser) },
        { to: '/servicelevellinks', icon: 'fa fa-link fa-flip-horizontal', title: 'Service Level Links', canShow: (isAdministrator || isSuperUser) },
        { to: '/messages', icon: 'fa fa-bullhorn', title: 'Broadcast Messages', canShow: (isAdministrator || isSuperUser) },
        { to: '/billsofmaterial', icon: 'fas fa-sort-numeric-down', title: 'BOM Management', canShow: (isAdministrator || isSuperUser) },
        { to: '/adminqueries', icon: 'fa fa-bomb', title: 'Admin Queries', canShow: (isAdministrator || isSuperUser) },
        { to: '/reports', icon: 'far fa-chart-bar', title: 'Report', canShow: loginInfo },
        { to: '/offlinezipstatus', icon: 'fas fa-file-download', title: 'My Report Requests', canShow: loginInfo  },
        { to: '/transactions', icon: 'fa fa-binoculars', title: 'Monitor Transactions', canShow: !isCustomer && loginInfo  },

    ];
    return (       
           
                <Security oktaAuth={oktaAuth} onAuthRequired={customAuthHandler} restoreOriginalUri={restoreOriginalUri}>
                        <CorsErrorModal {...{ corsErrorModalOpen, setCorsErrorModalOpen }} />
                        <AuthRequiredModal {...{ authRequiredModalOpen, setAuthRequiredModalOpen, triggerLogin }} />
                        <ScrollToTop />
                        <SideNavMenu links={links} showToggle={false}>
                            <Switch>
                           
                                <Route exact path='/' component={Home} />
                                <Route exact path='/login' component={Home} />
                                {/* <Route exact path='/' ><Redirect to={defaultRoute} /></Route> */}
                                {/* <Route path="/login" ><Redirect to={defaultRoute} /></Route>       */}
                                <Route path='/login/callback' render={(props) => <LoginCallback {...props} onAuthResume={onAuthResume} />} />
                                 
                      
                                <SecureRoute exact path='/dropoff' component={DropoffPage} />
                                <SecureRoute path='/dropoff/:dropoffId' component={EditDropoffPage} />
                                <SecureRoute exact path='/fieldasset' component={FieldAssetManagementPage} />
                                <SecureRoute path='/fieldasset/:assetId' component={FieldAssetManagementPage} />
                                <SecureRoute path='/editfieldasset/:assetId' component={EditFieldAssetPage} />
                                <SecureRoute exact path='/receiving' component={ReceivingPage} />
                                <SecureRoute path='/receiving/:assetId' component={ReceivingPage} />
                                <SecureRoute path='/rejectreason' component={RejectReasonPage} />
                                <SecureRoute path='/releasenotes' component={ReleaseNotesPage} />
                                <SecureRoute exact path='/addreleasenotes' component={AddReleaseNotesPage} />
                                <SecureRoute path='/addreleasenotes/:rnId' component={AddReleaseNotesPage} />
                                <SecureRoute path='/createasset/:searchText' component={CreateNewAssetPage} />
                                <SecureRoute path='/createawo/:searchText' component={CreateNewAWOPage} />
                                <SecureRoute exact path='/asset/:assetId' component={EditAssetPage} />
                                <SecureRoute path='/asset/:assetId/:prevLocation' component={EditAssetPage} />
                                <SecureRoute exact path='/inspection' component={InspectionPage} />
                                <SecureRoute path='/inspection/:jobId' component={InspectionPage} />
                                <SecureRoute exact path='/jobprogress' component={JobProgressPage} />
                                <SecureRoute path='/jobprogress/:assetId' component={EditAssetDescriptionPage} />
                                <SecureRoute path='/job/:jobId' component={EditJobPage} />
                                <SecureRoute exact path='/jobprogressassets/:jobId' component={JobProgressAssetsPage} />
                                <SecureRoute path='/jobprogressassets/:jobId/:serial' component={JobProgressAssetsPage} />
                                <SecureRoute path='/shipassets/:jobId' component={ShipAssetsPage} />
                                <SecureRoute path='/adhoctransactions/:jobId' component={AdhocTransactionsPage} />
                                <SecureRoute path='/transferassets/:jobId' component={TransferAssetsToJobPage} />
                                <SecureRoute path='/selectservicelevels/:jobId' component={SelectServiceLevelPage} />
                                <SecureRoute path='/sapjobprogress' component={SAPJobProgressPage} />
                                <SecureRoute exact path='/users' component={UsersPage} />
                                <SecureRoute path='/users/:userId' component={EditUserPage} />
                                <SecureRoute exact path='/customers' component={CustomerPage} />
                                <SecureRoute exact path='/customers/:customerId' component={EditCustomerPage} />
                                <SecureRoute path='/customers/documents/:customerId/:uploadType/:fromPage' component={CustomerDocumentUploadPage} />
                                <SecureRoute path='/configurecustomer/:customerId' component={ConfigureCustomerPage} />
                                <SecureRoute path='/customerlocations/:customerLocationId' component={CustomerLocationPage} />
                                <SecureRoute path='/customerservicelevel/:customerServiceLevelId' component={CustomerServiceLevelPage} />
                                <SecureRoute exact path='/facilities' component={FacilitiesPage} />
                                <SecureRoute path='/facilities/:facilityId' component={EditFacilityPage} />
                                <SecureRoute exact path='/manufacturerdescription' component={ManufacturerDescriptionPage} />
                                <SecureRoute path='/manufacturerdescription/:manDescId' component={EditManufacturerDescriptionPage} />
                                <SecureRoute exact path='/customerdescription' component={CustomerDescriptionPage} />
                                <SecureRoute path='/customerdescription/:custDescId' component={EditCustomerDescriptionPage} />
                                <SecureRoute path='/lists' component={ListPage} />
                                <SecureRoute exact path='/laborcodes' component={LaborCodePage} />
                                <SecureRoute exact path='/offlinezipstatus' component={LibertyReportPage} />
                                <SecureRoute path='/laborcodes/:laborCodeId' component={EditLaborCodePage} />
                                <SecureRoute path='/servicelevellinks' component={ServiceLevelLinkPage} />
                                <SecureRoute path='/billsofmaterial' component={BillOfMaterialPage} />
                                <SecureRoute path='/notes/:notetype/:id' component={NotesPage} />
                                <SecureRoute exact path='/adminqueries' component={AdminQueryPage} />
                                <SecureRoute exact path='/containers' component={ContainerPage} />
                                <SecureRoute exact path='/assetsearch' component={SerializedAssetSearchPage} />
                                <SecureRoute path='/assetdetail/:assetId' component={SerializedAssetDetailPage} />
                                <SecureRoute path='/messages' component={BroadcastMessagesPage} />
                                <SecureRoute exact path='/shippingtickets' component={ShippingTicketPage} />
                                <SecureRoute path='/shippingtickets/:ticketId' component={ShippingTicketDetailPage} />
                                <SecureRoute path='/shipreceivedassets' component={ShipReceivedAssetsPage} />
                                <SecureRoute path='/manualpressuretests' component={ManualPressureTestPage} />
                                <SecureRoute path='/reports' component={ReportsPage} />
                                <SecureRoute path='/jobattachments/:jobId/:jobNumber' component={JobAttachmentPage} />
                                <SecureRoute exact path='/receivingtickets' component={ReceivingTicketPage} />
                                <SecureRoute path='/receivingtickets/:ticketId' component={ReceivingTicketDetailPage} />
                                <SecureRoute path='/transactions' component={MonitorInterfacePage} />
                                <SecureRoute path='/quotesdetail/:jobNumber/:jobId' component={QuotesDetailPage} />
                                <SecureRoute path='/inspectionattachments/:assetId/:assetSerialNumber/:equipmentNumber' component={InspectionAttachmentPage} />
                                <SecureRoute path='/gaugemanagement' component={GaugeManagementPage} />
                                <SecureRoute exact path='/scannedqrasset' component={ScannedQRAssetsPage} />
                                <SecureRoute path='/scannedqrasset/:assetId' component={ScannedQRAssetsPage} />
                                <SecureRoute exact path='/assemblyworkorder' component={AssemblyWorkOrderPage} />
                                <SecureRoute path='/selectAssemblyLevels/:awoId' component={SelectAssemblyLevelPage} />
                                <SecureRoute exact path='/assembly' component={AssemblyPage} />
                                <SecureRoute path='/awoattachments/:awoId' component={AwoAttachmentPage} />
                                <SecureRoute exact path='/assemblyProgress/:assemblyId' component={AssemblyProgressPage} />
                                <SecureRoute path='/assemblyProgress/:assemblyId/:serial' component={AssemblyProgressPage} />
                                <SecureRoute path='/editawo/:awoId' component={EditAwoPage} />
                                <SecureRoute path='/duplicateawo/:awoId' component={DuplicateAwoPage} />
                                <SecureRoute path='/customerAssemblylevel/:customerAssemblyLevelId' component={CustomerAssemblyLevelPage} />
                                <SecureRoute path='/shipsawoassets/:awoId' component={ShipAwoAssetsPage}/>
                                <SecureRoute path='/assembly/:awoId' component={AssemblyPage} />
                                <Route component={NoSuchRoutePage} />
                            </Switch>
                        </SideNavMenu>
                        </Security>                   
     
            
    );
});

export default AppRouter;
